import { cn } from '@/lib/cn';

/** `onField`: a bone blob for headers that sit on a red or yellow field. */
export function LogoMark({ size = 32, className, onField }: { size?: number; className?: string; onField?: boolean }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden>
      <circle cx="30" cy="34" r="26" fill={onField ? '#F2EEE5' : '#ED4B44'} />
      <circle cx="21" cy="30" r="3.6" fill="#1A1A1A" />
      <circle cx="38" cy="30" r="3.6" fill="#1A1A1A" />
      <path d="M20 40q10 9 20 0" stroke="#1A1A1A" strokeWidth="4.2" fill="none" strokeLinecap="round" />
      <circle cx="54" cy="10" r="7" fill="#F2C21A" />
    </svg>
  );
}

export function Logo({ className, size = 28, onField }: { className?: string; size?: number; onField?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark size={size} onField={onField} />
      <span aria-hidden className="font-display text-[22px] leading-none" style={{ fontSize: size * 0.9 }}>
        popin
      </span>
      <span className="sr-only">Popin</span>
    </span>
  );
}
